(function () {
  'use strict';

  angular.module('app').component('clientDetail', clientDetail());

  function clientDetail() {
    return {
      bindings: {
        item: '=',
        mode: '<',
        fast: '<',
        hideTopControls: '<',
        onSavedItem: '&',
        onCanceledItem: '&',
      },
      controller: ClientDetailComponent,
      controllerAs: 'vm',
      templateUrl: './app/ajs/clients/client-detail/client-detail.component.html',
    };
  }

  ClientDetailComponent.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    'ClientService',
    'ClientTypeService',
    'ClientProfileService',
    'PriceListService',
    'LanguageService',
    'SessionService',
    'CreditPaymentTermService',
    '$location',

    // Angular downgraded service
    'countryService',
    'companyService',
    'currencyService',
  ];

  function ClientDetailComponent(
    config,
    UtilService,
    ClientService,
    ClientTypeService,
    ClientProfileService,
    PriceListService,
    LanguageService,
    SessionService,
    CreditPaymentTermService,
    $location,

    // Angular downgraded service
    countryService,
    companyService,
    currencyService
  ) {
    // public properties
    // -----------------------
    const vm = this;

    vm.UtilService = new UtilService(vm);

    vm.dateDisplay = config.DATE_DISPLAY;
    vm.activeStatus = config.ACTIVE;
    vm.inactiveStatus = config.INACTIVE;

    // private properties
    // -----------------------
    let cropedImage = { file: null };

    let company = SessionService.getSelectedAccountCompany();
    let userLanguageCode = SessionService.getUserLanguage().code;

    vm.$onInit = function () {
      vm.showFormField = true;

      if (vm.fast) {
        vm.showFormField = false;
      }

      if (vm.item.id) {
        // Edit
        setItemOptions(vm.item, vm.mode);
        getTaxIdTypesByCountry(vm.item.country);
        //fetchBills(vm.item.tax_id_number);
      } else {
        vm.createMode = true;

        vm.item = {
          credit_enabled: false,
          social_profiles: [],
          is_provider: false,
        };

        vm.stateLabel = 'STATE';
        vm.cityLabel = 'CITY';

        vm.labelAddLogo = 'ADD_PHOTO';

        // Initializers
        getCountries();
        getClientTypes();
        getClientProfiles();

        getPriceLists();
        getLanguages();
      }

      // Initializers
      getCompany();
    };

    // public methods
    // -----------------------
    vm.selectCommisionSettings = function () {
      getPriceLists();
    };

    vm.selectCountry = function (country) {
      if (vm.countrySelected && vm.countrySelected.id === country.id) {
        // Same country is selected
        return;
      }

      vm.countrySelected = country;

      vm.item.tax_id_code = null;
      vm.item.tax_id_number = null;

      vm.item.state_id = null;
      vm.item.city_id = null;
      vm.item.district_id = null;

      vm.taxIdType = null;

      vm.item.last_name = null;
      vm.showLastName = true;
      vm.lastNameRequired = false;

      if (!vm.item.phone_number) {
        vm.selectCountryPhone(country);
        vm.item.phone_code = country.phone_code;
      }

      getTaxIdTypesByCountry(country);
      setCountryStatesLabels(country);
      getCountryStates(country);
    };

    vm.selectTaxIdType = function (taxIdType) {
      vm.item.legal_id = null;

      vm.taxIdType = taxIdType;

      setLastNameRequired(taxIdType.code);
    };

    vm.selectClientType = function (client_type) {
      vm.clientTypeIsBusiness = client_type.is_business;
    };

    vm.selectState = function (state_id) {
      vm.item.city_id = null;
      vm.item.district_id = null;

      getCitiesByState(state_id);
    };

    vm.selectCity = function (city_id) {
      vm.item.district_id = null;

      getDistrictsByCity(city_id);
    };

    vm.selectCountryPhone = function (country) {
      vm.countryPhoneSelected = country;
    };

    vm.selectCountrySecondaryPhone = function (country) {
      vm.countrySecondaryPhoneSelected = country;
    };

    vm.selectCountryMobile = function (country) {
      vm.countryMobileSelected = country;
    };

    vm.selectCountryFax = function (country) {
      vm.countryFaxSelected = country;
    };

    vm.openClientTypesModal = function () {
      ClientTypeService.openClientTypesModal(getClientTypes);
    };

    vm.openClientProfileInfoModal = function (clientProfileId) {
      ClientProfileService.openClientProfileInfoModal(clientProfileId);
    };

    vm.addSocialProfile = function () {
      vm.item.social_profiles.push({
        createMode: true,
      });
    };

    vm.removeSocialProfile = function (index) {
      vm.item.social_profiles.splice(index, 1);
    };

    vm.changeSocialProfileStatus = function (item) {
      item.status = item.status === vm.activeStatus ? vm.inactiveStatus : vm.activeStatus;
    };

    vm.openCreditPaymentTermsModal = function () {
      let successCallback = function () {
        CreditPaymentTermService.getCreditPaymentTerms({ skip_check_role: true }).then(function (
          data
        ) {
          vm.company.credit_payment_terms = data;
        });
      };

      CreditPaymentTermService.openCreditPaymentTermsModal(
        vm.company.credit_payment_terms,
        company.id,
        successCallback
      );
    };

    vm.editClient = function () {
      vm.editMode = true;
      vm.viewMode = false;

      // Initializers
      getCountries();
      getClientTypes();
      getClientProfiles();

      getPriceLists();
      getLanguages();

      setCountryStatesLabels(vm.item.country);
      getCountryStates(vm.item.country);
    };

    vm.cancelEdit = function () {
      // If we cancel the edition when changing country
      if (vm.originalItem.country_id !== vm.item.country_id) {
        getTaxIdTypesByCountry(vm.originalItem.country);
      }

      vm.item = vm.originalItem;
      setItemOptions(vm.item);
    };

    vm.openLogo = function () {
      let logoSaved = (cropedImageObj) => {
        cropedImage = cropedImageObj;

        if (vm.editMode) {
          ClientService.updateLogo(vm.item, cropedImage);
        } else {
          var img = document.getElementById('logo-image-preview'); // <HTMLInputElement>
          img.src = URL.createObjectURL(cropedImage.file);
        }
      };

      ClientService.openLogo(vm.item, logoSaved);
      // getClient(vm.item.id);
    };

    vm.deleteLogo = function () {
      vm.item.logo = null;
      vm.item.logoUrl = null;
      ClientService.deleteLogo(vm.item);
    };

    // Create/Update
    vm.saveClient = function (isFormValid) {
      vm.formErrors = false;

      let to = vm.hideTopControls ? 'clients' : '';

      if (!isFormValid) {
        vm.serverErrors = [];
        vm.formErrors = true;

        vm.UtilService.scrollToTop(to);

        return;
      }

      // Do not send relations
      let item = angular.copy(vm.item);

      delete item.client_type;
      delete item.country;
      delete item.client_profile;

      delete item.contacts;

      if (!vm.showLastName) {
        item.last_name = ''; // Reset last_name if doest not apply
      }

      createClient(item, cropedImage, to);
    };

    vm.cancel = function () {
      /*if (vm.editMode){
                vm.cancelEdit();
                return;
            }*/

      vm.onCanceledItem({ item: vm.item });
    };

    vm.onShowProvider = function (id) {
      $location.path(`/providers/${id}`);
    };

    // private methods
    // -----------------------
    function setItemOptions(item, mode = '') {
      vm.createMode = false;
      vm.editMode = false;
      vm.viewMode = true;

      if (mode === 'edit') {
        vm.editClient();
      }

      vm.clientTypeIsBusiness = (item.client_type && item.client_type.is_business) || false;

      vm.countrySelected = item.country;
      if (vm.countrySelected) {
        setCountryStatesLabels(vm.countrySelected);
      }

      vm.item.is_provider = vm.item.is_provider === undefined ? false : vm.item.is_provider;
      vm.item.social_profiles = item.social_profiles || [];

      vm.itemName = item.name;
      if (item.last_name && vm.showLastName) {
        vm.itemName += ' ' + item.last_name;
      }

      vm.labelAddLogo = item.logo.url ? 'CHANGE_PHOTO' : 'ADD_PHOTO';

      vm.originalItem = angular.copy(item); // store server data
    }

    function getCompany() {
      vm.loadingCompany = true;
      companyService
        .getCompany(company.id, { skip_check_role: true, lang: userLanguageCode })
        .subscribe((response) => {
          vm.company = response;

          vm.atvCrEnabled =
            vm.company.company_integration && vm.company.company_integration.atv_cr_enabled
              ? true
              : false;

          if (vm.viewMode && vm.item.default_credit_payment_term_id) {
            vm.creditPaymentTerm = vm.UtilService.findItemInArray(
              vm.company.credit_payment_terms,
              'id',
              vm.item.default_credit_payment_term_id
            );
          }

          getCurrencies(vm.company.currency_ids);

          vm.loadingCompany = false;
        });
    }

    function getCurrencies(companyCurrencyIds) {
      let params = {
        get: 'per_company',
        'currency_ids[]': companyCurrencyIds,
        skip_check_role: true,
      };

      vm.loadingCurrenciesPerCompany = true;
      currencyService.getCurrencies(params).subscribe((response) => {
        vm.currenciesPerCompany = response;

        vm.loadingCurrenciesPerCompany = false;
      });
    }

    function getCountries() {
      if (vm.countries) return;

      vm.loadingCountries = true;
      countryService
        .getCountries({ get: 'active', skip_check_role: true })
        .subscribe((response) => {
          vm.countries = response;

          if (!vm.createMode && vm.item.phone_code) {
            let countryPhone = vm.UtilService.findItemInArray(
              vm.countries,
              'phone_code',
              vm.item.phone_code
            );

            vm.selectCountryPhone(countryPhone);
          }

          vm.loadingCountries = false;
        });
    }

    function getStatesByCountry() {
      let params = {
        get: 'active',
        skip_check_role: true,
      };

      countryService.getStates(vm.item.country_id, params).subscribe((response) => {
        vm.statesByCountry = response;
      });
    }

    function getCitiesByState(state_id) {
      let params = {
        get: 'active',
        by_state: state_id,
        skip_check_role: true,
      };

      countryService.getCities(vm.item.country_id, params).subscribe((response) => {
        vm.citiesByState = response;
      });
    }

    function getDistrictsByCity(city_id) {
      let params = {
        get: 'active',
        by_city: city_id,
        skip_check_role: true,
      };

      countryService.getDistricts(vm.item.country_id, params).subscribe((response) => {
        vm.districtsByCity = response;
      });
    }

    function getClientTypes() {
      if (vm.clientTypes) return;

      vm.loadingClientTypes = true;
      ClientTypeService.getClientTypes({ get: 'active', skip_check_role: true }).then(function (
        data
      ) {
        vm.clientTypes = data.items;

        if (vm.fast) {
          for (let i = 0; i < vm.clientTypes.length; i++) {
            if (vm.clientTypes[i].predefined) {
              vm.item.client_type_id = vm.clientTypes[i].id;

              break;
            }
          }
        }

        vm.loadingClientTypes = false;
      });
    }

    function getClientProfiles() {
      if (vm.clientProfiles) return;

      vm.loadingClientProfiles = true;
      ClientProfileService.getClientProfiles({ get: 'active', skip_check_role: true }).then(
        function (data) {
          vm.clientProfiles = data.items;

          if (vm.fast) {
            for (let i = 0; i < vm.clientProfiles.length; i++) {
              if (vm.clientProfiles[i].is_default) {
                vm.item.client_profile_id = vm.clientProfiles[i].id;
                break;
              }
            }
          }

          vm.loadingClientProfiles = false;
        }
      );
    }

    function getPriceLists() {
      if (vm.priceLists) return;

      let params = {
        get: 'active',
        contact_type: 'client',
        skip_check_role: true,
      };

      PriceListService.getPriceLists(params).then(function (data) {
        vm.priceLists = data.items;
      });
    }

    function getLanguages() {
      if (vm.languages) return;

      LanguageService.getLanguages({ get: 'active', skip_check_role: true }).then(function (data) {
        vm.languages = data.items;
      });
    }

    function setCountryStatesLabels(country) {
      vm.stateLabel = 'STATE';
      vm.cityLabel = 'CITY';

      if (country.enable_states) {
        vm.stateLabel = 'PROVINCE';
        vm.cityLabel = 'CANTON';
      }
    }

    function getCountryStates(country) {
      if (country.enable_states) {
        getStatesByCountry();

        if (vm.item.state_id) {
          getCitiesByState(vm.item.state_id);
        }

        if (vm.item.city_id) {
          getDistrictsByCity(vm.item.city_id);
        }
      }
    }

    function getTaxIdTypesByCountry(country) {
      // TODO: what about the rest of the countries?
      // if (country.code !== 'CR'){
      //     return;
      // }

      // console.log(company);

      let companyCountryCode = company.country.code;

      let params = {
        // country_code:    country.code,
        country_code: companyCountryCode,
        skip_check_role: true,
        lang: userLanguageCode,
      };

      vm.loadingTaxIdTypes = true;
      countryService.getTaxIdTypesByCountry(params).subscribe((response) => {
        vm.taxIdTypesByCountry = response;

        vm.taxIdType = vm.UtilService.findItemInArray(response, 'code', vm.item.tax_id_code);

        setLastNameRequired(vm.item.tax_id_code);

        vm.loadingTaxIdTypes = false;
      });
    }

    function setLastNameRequired(taxIdCode) {
      if (taxIdCode === '02') {
        // company type
        vm.showLastName = false;
        vm.lastNameRequired = false;
      } else {
        vm.showLastName = true;
        vm.lastNameRequired = true;
      }
    }

    function createClient(item, cropedImage, to) {
      vm.sendingForm = true;
      ClientService.saveClient(item, cropedImage).then(
        function (response) {
          let data = response.data;

          if (!vm.editMode) {
            // Create
            vm.onSavedItem({ item: data });
          } else {
            // Edit
            vm.item = data; // reload item
            vm.item.logoUrl = data.logo.url;
            setItemOptions(data);

            if (data.default_credit_payment_term_id) {
              vm.creditPaymentTerm = vm.UtilService.findItemInArray(
                vm.company.credit_payment_terms,
                'id',
                data.default_credit_payment_term_id
              );
            }

            vm.UtilService.scrollToTop(to);
          }

          vm.sendingForm = false;
        },
        function (response) {
          vm.serverErrors = vm.UtilService._showItemServerErrors(response.data.errors);
          vm.formErrors = true;
          vm.UtilService.scrollToTop(to);

          vm.sendingForm = false;
        }
      );
    }
  }
})();
